var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-shell',[_c('month',{attrs:{"year":_vm.year,"month":_vm.month}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }